import { cascaderCarType } from '../../common/utils/typeDict';

export default class {
  initModelValue(){
    // 搜索列表，进行足组件值的回显，如果没有this.value,不更新回显
    if (!this.value) {
      return;
    }
    this.modelValue = this.cascaderCarTypeFlat.find(i=> i.value.toString() === this.value.toString());
  }
}
